import React from "react";
import './Map.scss'
import { EntityComplaint } from "types/EntityComplaint";
import District from "../District/District";
import { OnNavigateFunction } from "types/ListAndDetailTypes";


interface MapProps {
    districts: EntityComplaint[]
    handleNavigation: OnNavigateFunction
}

const Map: React.FC<MapProps> = ({ districts, handleNavigation }) => {
    return (<div className="custom-israel-map-container">
        <div className="custom-israel-map">
            <div className="map">
                <div className="districts-container w-100 d-flex flex-wrap row-gap-5">
                    {districts &&
                        districts.map((item: any) => (
                            <District
                                district={item}
                                key={item.id}
                                onNavigate={handleNavigation}
                            />
                        ))}
                </div>
            </div>
        </div>
    </div>);
}

export default Map;
